import { getCivilDateParts, toCivilYmd } from "./date-only";

/** .NET / SQL placeholder calendar dates that must never reach forms or APIs. */
export function isSentinelCalendarYmd(ymd: string): boolean {
  return ymd.startsWith("0000-") || ymd.startsWith("0001-");
}

/** Normalize API date-only values for UI forms and tables without timezone drift. */
export function normalizeTimeEntryDateYmd(
  value: Date | string | null | undefined,
): string {
  if (!value) return "";
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
      const ymd = trimmed.slice(0, 10);
      return isSentinelCalendarYmd(ymd) ? "" : ymd;
    }
  }
  const parts = getCivilDateParts(value);
  if (parts && parts.year < 1900) return "";
  const ymd = toCivilYmd(value);
  if (!ymd) return "";
  return isSentinelCalendarYmd(ymd) ? "" : ymd;
}

/** UTC noon keeps OpenAPI `toISOString().substring(0, 10)` on the chosen calendar day. */
export function timeEntryYmdToApiDate(ymd: string): Date {
  return new Date(`${ymd}T12:00:00.000Z`);
}

/** Prefer a valid form date; otherwise keep the entry date when editing time only. */
export function resolveTimeEntrySubmitDateYmd(
  formYmd: string,
  fallbackYmd?: string | null,
): string {
  if (formYmd && !isSentinelCalendarYmd(formYmd)) return formYmd;
  if (fallbackYmd && !isSentinelCalendarYmd(fallbackYmd)) return fallbackYmd;
  return formYmd;
}
